<div class="form-group" ngModelGroup="formField{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div class="w-100">
        @if (!isTypeahead) {
            @if (isReadOnlyField) {
                <div
                    id="form-element-{{ formField.id }}"
                    class="readonly-name-with-email-field form-control text-break"
                    ngDefaultControl>
                    {{ formField.valueModel }}
                </div>
            } @else {
                <div class="input-container input-facebook">
                    <input
                        class="form-control"
                        id="form-element-{{ formField.id }}"
                        autocomplete="email"
                        name="email"
                        appFocus
                        [appAutoFocus]="formField.isNeedToFocus"
                        [placeholder]="formField.placeholder"
                        [required]="formField.isRequired"
                        [(ngModel)]="formField.value"
                        [pattern]="formField.options?.pattern"
                        #field="ngModel"
                        sbTrim
                        appEmailValidator
                        maxlength="1000" />
                    @if (isFBEnabled) {
                        <button
                            type="button"
                            [attr.aria-label]="'Facebook login' | translate"
                            class="btn btn-icon fb-icon btn-transparent"
                            (click)="login()">
                            <sb-inline-svg
                                class="icon"
                                [url]="'sb-tools/theme/images/Svg icons WEB/Web icons/Facebook icon.svg'">
                            </sb-inline-svg>
                        </button>
                    }
                </div>
                <ng-container *ngTemplateOutlet="errTemplate; context: { field: field }"></ng-container>
            }
        } @else {
            <div class="position-relative">
                <input
                    id="form-element-{{ formField.id }}"
                    name="formField{{ formField.id }}"
                    autocomplete="off"
                    class="form-control"
                    typeaheadOptionField="label"
                    appFocus
                    [appAutoFocus]="formField.isNeedToFocus"
                    [typeaheadSelectFirstItem]="false"
                    [typeaheadIsFirstItemActive]="false"
                    [placeholder]="formField.placeholder"
                    [typeaheadMinLength]="0"
                    [typeahead]="allUsers"
                    [typeaheadGroupField]="'typeName'"
                    [typeaheadScrollable]="true"
                    [typeaheadOptionsInScrollableView]="4"
                    [typeaheadItemTemplate]="customItemTemplate"
                    (typeaheadOnSelect)="addUser($event)"
                    [(ngModel)]="formField.value"
                    [required]="formField.isRequired"
                    [pattern]="formField.options?.pattern"
                    #field="ngModel"
                    sbTrim
                    appEmailValidator />

                <ng-template #customItemTemplate let-model="item" let-index="index">
                    <div class="d-flex align-items-center mt-1 mb-1">
                        @if (!model.isContact) {
                            <sb-user-avatar
                                class="user-avatar-btn"
                                [user]="model"
                                [size]="'btn'"
                                [isNeedTooltip]="false">
                            </sb-user-avatar>
                        } @else {
                            <sb-inline-svg
                                class="icon check-icon me-2"
                                style="padding: 2px"
                                [url]="'/sb-tools/theme/images/icons/contact.svg'">
                            </sb-inline-svg>
                        }

                        <div class="truncate">
                            <div class="truncate text-light">
                                <span class="truncate-name">
                                    {{ model.name | truncate: 23 }}
                                </span>
                                <small class="text-light ms-1">{{ model.email }}</small>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
            <ng-container *ngTemplateOutlet="errTemplate; context: { field: field }"></ng-container>
        }
    </div>
</div>

<ng-template #errTemplate let-field="field">
    @if (formService.isSubmitted) {
        @if (field.errors?.validateEmail) {
            <div class="text-danger" translate>Please enter a valid email address</div>
        }
        @if (field.errors?.pattern) {
            <div class="text-danger">
                @if (formField.options?.patternErrorText) {
                    {{ formField.options.patternErrorText }}
                } @else {
                    {{ 'Invalid field value' | translate }}
                }
            </div>
        }
        @if (field.errors?.required) {
            <div class="text-danger" translate>Please fill this field</div>
        }
    }
</ng-template>
